import type { ComponentProps } from 'react';
import { MemberAvatar } from '@gonfalon/members/MemberAvatar';
import { memberInitials } from '@gonfalon/members/memberInitials';
import { type MaintainerTeam, type MemberSummary } from '@gonfalon/members/types';
import { Icon } from '@launchpad-ui/icons';

type MaintainerAvatarProps = {
  member?: MemberSummary;
  team?: MaintainerTeam;
  size?: ComponentProps<typeof MemberAvatar>['size'];
};

export function MaintainerAvatar({ member, team, size = 'medium' }: MaintainerAvatarProps) {
  if (member) {
    return <MemberAvatar size={size} email={member.email} initials={memberInitials(member)} />;
  }

  if (team) {
    return <Icon size={size} name="group" />;
  }

  return null;
}
